import {makeAutoObservable, observable} from 'mobx'

interface State {
  modified: number
}

export class PendingCompanyUserStore {
  state: State = {modified: 0}
  constructor() {
    makeAutoObservable(this, {state: observable.shallow}, {autoBind: true})
  }

  update() {
    this.state.modified++
  }
}

export const pendingCompanyUserStore = new PendingCompanyUserStore()
